import { render, staticRenderFns } from "./form-row-edit-phone.vue?vue&type=template&id=14978986&scoped=true&"
import script from "./form-row-edit-phone.vue?vue&type=script&lang=js&"
export * from "./form-row-edit-phone.vue?vue&type=script&lang=js&"
import style0 from "./form-row-edit-phone.vue?vue&type=style&index=0&id=14978986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14978986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14978986')) {
      api.createRecord('14978986', component.options)
    } else {
      api.reload('14978986', component.options)
    }
    module.hot.accept("./form-row-edit-phone.vue?vue&type=template&id=14978986&scoped=true&", function () {
      api.rerender('14978986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-edit-phone.vue"
export default component.exports